export interface DealsApprovalOkRequest {

    dealingRoomActions: DealingRoomAction[];
}

export interface DealingRoomAction {

    id: number;
    type: DealingRoomActionTpe;
}

export enum DealingRoomActionTpe {

    MarketOrder = 0,
    EntryOrder = 1
}
